<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'AddBtn',
})
</script>
<template>
  <Button type="link" v-bind="$attrs" :style="{ height }">
    <template #icon>
      <PlusOutlined />
    </template>
    <slot />
  </Button>
</template>

<script lang="ts" setup name="AddBtn">
import { PlusOutlined } from '@ant-design/icons-vue'
import { Button } from 'ant-design-vue'
withDefaults(
  defineProps<{
    height?: string
  }>(),
  {
    height: 'auto'
  }
)
</script>
